import React from "react";
import { Link } from "react-router";
import ICONS from "src/assets/icons";
// import whitecloudoor from "src/assets/images/whitecloudoor.png";

const FooterSection: React.FC = () => {
  return (
    <footer className="bg-[#05132D] text-white py-10 px-[6vw] mt-[5rem]">
      <div className="container mx-auto flex flex-col md:flex-row justify-between gap-8">
        <div className="md:w-2/4 items-start">
          <Link to="/" className="flex items-baseline">
            {/* {ICONS.CloudDoorLoop()}
            <span className="text-[24px] font-bold text-white">DOOR</span> */}
            <span className="text-[2.5rem] font-bold text-white">d</span>
            {ICONS.CloudDoorLoop()}
            <span className="text-[2.5rem] font-bold text-white">r</span>
            {/* <img src={whitecloudoor} alt="Door" className="h-6 sm:h-8 md:h-10 lg:h-8 xl:h-8" /> */}
          </Link>
          <p className="text-[16px] mt-2 text-[#FFFFFFBF]">
          Avec DOOR, passez à un Cloud souverain 100% moderne, libéré du Legacy, pour une performance maximale.
          </p>
          <div className="flex gap-4 mt-4">
            {/* <Link to="#" className="hover:text-white">
              <i className="bi bi-twitter-x"></i>
            </Link> */}
            <Link
              to="https://www.linkedin.com/company/cloudoor"
              className="hover:text-white"
              target="_blank"
            >
              <i className="bi bi-linkedin"></i>
            </Link>
            <Link
              to="https://x.com/CloudoorApp"
              className="hover:text-white"
              target="_blank"
            >
              <i className="bi bi-twitter-x"></i>
            </Link>
          </div>
        </div>
        <div className="md:w-1/4 items-start"></div>
        <div className="md:w-1/4 flex flex-col items-start">
          {/* <h3 className="text-[16px] font-[400] mb-2">Quick Links</h3>
          <ul className="space-y-1 text-[16px] text-[#FFFFFFBF]">
            <li>
              <Link to="#" className="hover:text-white">
                How it works
              </Link>
            </li>
            <li>
              <Link to="#" className="hover:text-white">
                Solutions
              </Link>
            </li>
            <li>
              <Link to="#" className="hover:text-white">
                About us
              </Link>
            </li>
            <li>
              <Link to="#" className="hover:text-white">
                Case study
              </Link>
            </li>
          </ul> */}
        </div>
        <div className="md:w-1/4 flex flex-col items-start">
          <h3 className="text-[16px] font-[400] mb-2">Community</h3>
          <ul className="space-y-1 text-[16px] text-[#FFFFFFBF]">
            <li>
              <Link
                to="https://www.linkedin.com/company/cloudoor"
                className="hover:text-white"
                target="_blank"
              >
                LinkedIn
              </Link>
            </li>
            <li>
              <Link
                to="https://x.com/CloudoorApp"
                className="hover:text-white"
                target="_blank"
              >
                Twitter (X)
              </Link>
            </li>
            {/* <li>
              <Link to="#" className="hover:text-white">
                Facebook
              </Link>
            </li>
            <li>
              <Link to="#" className="hover:text-white">
                Instagram
              </Link>
            </li>
            <li>
              <Link to="#" className="hover:text-white">
                Discord
              </Link>
            </li>
            <li>
              <Link to="#" className="hover:text-white">
                Reddit
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-700 mt-8 pt-4 text-center text-[16px] flex items-center">
        <div className="flex flex-col md:flex-row gap-4 flex-1">
          <Link to="#" className="hover:text-white">
            Terms of use
          </Link>
          <span className="hidden md:inline">|</span>
          <Link to="#" className="hover:text-white">
            Privacy policy
          </Link>
        </div>
        <p className="mt-2">© 2025 Company. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default FooterSection;
